import { graphql } from "@/api/graphql/types/gql.ts";

export const deleteFormDataRuleGroupMutation = graphql(`
  mutation DeleteFormDataRuleGroup($id: ID!) {
    MiddleMsDeleteFormDataRuleGroup(request: { id: $id })
  }
`);
